<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section cy="chart-filters">
    <h4 class="mb-2 full-width d-flex">
      Filters
      <span class="ui-spacer"></span>
      <span v-if="!hideDates" @click="setDateToPastWeek()" class="d-inline-block mr-2 pointer">Last 7 days</span>
      <span v-if="!hideDates" @click="setDateToPastMonth()" class="pointer">Last 30 days</span>
<!--       <span @click="setDateToPastYear()" class="pointer text-danger">Last Year</span>-->
    </h4>

    <h5 v-if="!filters.before || !filters.after">Please select a date range to start</h5>

    <div class="row mb-2">
      <section v-if="!hideDates" class="col-3">
        <label>After Date (Inclusive)</label>
        <b-form-datepicker @input="updateAfterDateFilter" :value="filters.after" locale="en-UK" cy="after-date"
                           today-button
                           close-button
                           :date-disabled-fn="dateDisabled"
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section v-if="!hideDates" class="col-3">
        <label>Up to Date (Inclusive)</label>
        <b-form-datepicker @input="updateBeforeDateFilter" :value="filters.before" locale="en-UK" cy="before-date"
                           :min="filters.after"
                           :max="maxBeforeDate"
                           today-button
                           close-button
                           :date-disabled-fn="dateDisabled"
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section class="col-3" v-if="filters.before && filters.after">
        <label>Group</label>

        <b-form-select cy="prison-group-select" @change="updatePrisonGroupFilter" :value="filters.prisonGroupId" class="mb-2" :class="{'disabled': loadingPrisonGroups}">
          <b-form-select-option v-for="group in prisonGroups" :key="group.group_id" :value="group.group_id">{{ group.name }}</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-3" v-if="filters.prisonGroupId && filters.before && filters.after">
        <label>Establishment</label>
        <b-form-select cy="prison-select" @change="updatePrisonNameFilter" :value="filters.prisonId" class="mb-2" :class="{'disabled': loadingPrison}">
          <b-form-select-option value="">Choose a establishment</b-form-select-option>
          <b-form-select-option v-for="prison in prisons" :key="prison.prison_id" :value="prison.prison_id">{{ prison.name }}</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-3" v-if="filters.prisonId && !hideCompare">
        <label>Compare Establishment</label>
        <b-form-select cy="prison-select-compare" @change="updateComparePrisonNameFilter" :value="compareFilters.prisonId" class="mb-2" :class="{'disabled': loadingPrison}">
          <b-form-select-option value="">Choose a establishment to compare</b-form-select-option>
          <b-form-select-option v-for="prison in prisons" :key="prison.prison_id" :value="prison.prison_id">{{ prison.name }}</b-form-select-option>
        </b-form-select>
      </section>
    </div>

    <h5 class="mb-2" v-if="filters.prisonGroupId">Showing results for {{filters.prisonId ? 'establishment' : 'group'}}</h5>
  </section>
</template>
<!-- eslint-enable -->

<script>
  import moment from 'moment';
  import { mapState } from 'vuex';
  import AnalystUsersService from '../../services/AnalystUsersService';

  export default {
    components: {},
    props: {
      hideDates: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loadingPrisonGroups: false,
        loadingPrison: false,
        compareMode: false,
        maxBeforeDate: '',
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        filters: state => state.stats.filters,
        compareFilters: state => state.stats.compareFilters,
        prisons: state => state.stats.prisons,
        prisonGroups: state => state.stats.prisonGroups,
        hideCompare: state => state.stats.hideCompare,
      }),
    },
    mounted() {
      this.getPrisonGroups();

      if (!this.filters.before && !this.filters.after) { // on first load set to last weeks data
        this.setDateToPastWeek();
      }
    },
    methods: {
      setDateToPastWeek() {
        const before = moment().format('YYYY-MM-DD');
        this.updateBeforeDateFilter(before);
        this.updateAfterDateFilter(moment(before).subtract(7, 'days').format('YYYY-MM-DD'));
      },
      setDateToPastMonth() {
        const before = moment().format('YYYY-MM-DD');
        this.updateBeforeDateFilter(before);
        this.updateAfterDateFilter(moment(before).subtract(1, 'months').format('YYYY-MM-DD'));
      },
      setDateToPastYear() {
        const before = moment().format('YYYY-MM-DD');
        this.updateBeforeDateFilter(before);
        this.updateAfterDateFilter(moment(before).subtract(1, 'years').format('YYYY-MM-DD'));
      },
      getPrisonGroups() {
        this.loadingPrisonGroups = true;
        AnalystUsersService.getPrisonGroups().then(res => {
          // console.log('got prison groups', res);
          this.$store.commit('stats/SET_PRISON_GROUPS', res.data);
          this.loadingPrisonGroups = false;

          // set prison group if not already set
          if (!this.filters.prisonGroupId && res.data.length > 0) {
            this.updatePrisonGroupFilter(res.data[0].group_id);
          }
        }).catch(err => {
          console.log('could not get prison groups', err);
          this.$toast.error('Could not get prison groups, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      getPrisonsInGroup(groupId) {
        this.loadingPrison = true;
        AnalystUsersService.getPrisonsInGroup(groupId).then(res => {
          // console.log('got prisons', res);
          this.setPrisonFromWhitelist(res.data);
          this.loadingPrison = false;
          this.$store.commit('stats/SET_LOADED', true);
        }).catch(err => {
          console.log('could not get prisons', err);
          this.$toast.error('Could not get prisons in prison group, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      setPrisonFromWhitelist(prisons) {
        let allowedPrisons = [];
        const whitelist = this.user.prisons_whitelist;

        if (whitelist && whitelist.length > 0) {
          prisons.forEach(prison => {
            const found = whitelist.find(id => id === prison.prison_id);

            if (found) {
              allowedPrisons.push(prison);
            }
          });
          // if there is a whitelist, set the prisonId filters
          this.updateMultiplePrisonsFilter(allowedPrisons.map(prison => prison.prison_id));
        } else {
          allowedPrisons = prisons;
        }

        // sort by name
        allowedPrisons.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }

          return 0; // names must be equal
        });

        this.$store.commit('stats/SET_PRISONS', allowedPrisons);
      },
      updatePrisonGroupFilter(e) {
        this.$store.commit('stats/SET_FILTER_ITEM', { name: 'prisonGroupId', value: e });
        this.updatePrisonNameFilter(''); // reset prison id
        this.updateComparePrisonNameFilter('');

        if (e) { // get new prison if group wasn't reset
          this.getPrisonsInGroup(e);
        } else {
          this.prisons = [];
        }
      },
      updatePrisonNameFilter(e) {
        this.$store.commit('stats/SET_FILTER_ITEM', { name: 'prisonId', value: e });

        if (e.length === 0) { // remove compare mode if prison reset
          this.updateComparePrisonNameFilter(e);
        }
      },
      updateComparePrisonNameFilter(e) {
        this.$store.commit('stats/SET_COMPARE_FILTER_ITEM', { name: 'prisonId', value: e });
        this.$store.commit('stats/SET_COMPARE_MODE', e.length > 0);
      },
      updateMultiplePrisonsFilter(e) {
        this.$store.commit('stats/SET_FILTER_ITEM', { name: 'prisonIds', value: e });
      },
      updateBeforeDateFilter(e) {
        this.$store.commit('stats/SET_FILTER_ITEM', { name: 'before', value: e });
        this.$store.commit('stats/SET_COMPARE_FILTER_ITEM', { name: 'before', value: e });
      },
      updateAfterDateFilter(e) {
        this.$store.commit('stats/SET_FILTER_ITEM', { name: 'after', value: e });
        this.$store.commit('stats/SET_COMPARE_FILTER_ITEM', { name: 'after', value: e });
        // this.updateBeforeDateFilter(moment(e).add(7, 'days').format('YYYY-MM-DD')); // set after date filter
        this.setMaxBeforeDate();
      },
      // eslint-disable-next-line no-unused-vars
      dateDisabled(ymd, date) {
        return moment(ymd).isBefore('2021-02-01', 'day');
      },
      setMaxBeforeDate() {
        this.maxBeforeDate = moment(this.filters.after).add(31, 'days').format('YYYY-MM-DD');
      },
    },
  };
</script>
